export function testimonialHomeSlider() {
    
    $(".testimonial-home-slider").slick({
        arrows: true,
        prevArrow: "<button class='prev ocean-prev'><svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M6.24625 0L0.24625 6L6.24625 12L7.75 10.5L3.24625 6L7.75 1.5L6.24625 0Z' fill='white'/></svg></button>",   
        nextArrow:"<button class='next ocean-right'><svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M1.75375 0L7.75375 6L1.75375 12L0.25 10.5L4.75375 6L0.25 1.5L1.75375 0Z' fill='white'/></svg></button>",
        dots: false,
        mobileFirst: true,
        adaptiveHeight: true,
        slidesToShow: 1,
        infinite: false,
        appendArrows: ".testimonial-slider-nav",
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2.5
                    
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/testimonialHomeSlider.js